import angular from 'angular';

import {ErrorService} from './error.service.js';
import {errorSource} from './error.directives.js';
import {ErrorController} from './error.controller.js';

angular
  .module('error', ['ui.bootstrap'])
  .factory('ErrorFactory', ErrorService.ErrorFactory)
  .directive('errSrc', errorSource)
  .controller('ErrorController', ErrorController);
